// The secret needs to be the same on the client and server side
// Client side code: themes/base/js/modules/crypt-aes.js
// Server side code: silverstripe-sasky-chat/socketClusterServer/crypt-aes.js

// import AES from 'crypto-js/enc-aes';
import CryptoJS from 'crypto-js';

module.exports.crypt = {
    secret : "8`jXi8f+@<~A=FJ/", // Needs to be the same on the client and server side. See above for the files locations.
    encrypt : function (clear){
        // encrypt() : encrypt the given clear text

        var cipher = CryptoJS.AES.encrypt(clear, this.secret);
        cipher = cipher.toString();
        return cipher;
    },

    decrypt : function (cipher) {
        // decrypt() : decrypt the given cipher text

        var decipher = CryptoJS.AES.decrypt(cipher, this.secret);
        decipher = decipher.toString(CryptoJS.enc.Utf8);
        return decipher;
    }
 };



// WEBPACK FOOTER //
// ./js/modules/crypt-aes.js